const INFRASTRUCTURE_LABELS = [
  'Energetická náročnost budovy',
  'Centrální vysavač',
  'Vytápěcí těleso',
  'Zdroj vytápění',
  'Ohřev vody',
  'Telekomunikace',
  'Veřejné vybavení',
  'Typ internetu',
  'Elektřina',
  'Kanalizace',
  'Komunikace',
  'Vodovod',
  'Plynovod',
  'Doprava',
  'Internet',
  'Plyn',
]

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
const labelPattern = new RegExp(`(${INFRASTRUCTURE_LABELS.map(escapeRegExp).join('|')}):`, 'g')

export const cleanInfrastructureText = (value) =>
  String(value || '')
    .replace(/(?:^|\s)\.[a-zA-Z0-9_-]+\s*\{[^{}]*\}/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

export const parseInfrastructure = (value) => {
  const cleaned = cleanInfrastructureText(value)
  if (!cleaned) return { entries: [], items: [] }

  const matches = [...cleaned.matchAll(labelPattern)]
  if (!matches.length) {
    return {
      entries: [],
      items: cleaned.split(/\s*,\s*/).map((item) => item.trim()).filter(Boolean),
    }
  }

  const entries = matches
    .map((match, index) => {
      const nextMatch = matches[index + 1]
      const start = match.index + match[0].length
      const end = nextMatch?.index ?? cleaned.length
      return {
        label: match[1],
        value: cleaned.slice(start, end).replace(/^[\s,;]+|[\s,;]+$/g, '').trim(),
      }
    })
    .filter((entry) => entry.value)

  return { entries, items: [] }
}
